import { Product, Testimonial } from '../types';
import img1 from '../assets/img1.jpeg';
import img2 from '../assets/img2.jpeg';
import img3 from '../assets/img3.jpeg';
import img4 from '../assets/img4.jpeg';
import img5 from '../assets/img5.jpeg';
import img6 from '../assets/img6.jpeg';
import img7 from '../assets/img7.jpeg';

export const products: Product[] = [
  {
    id: '1',
    title: 'Custom Calligraphy Table',
    description: 'Beautiful hand-crafted calligraphy on premium wooden tables. Perfect for dining rooms, coffee tables, or as a statement piece in your home.',
    price: 299.99,
    images: [img1, img2],
    category: 'Tables',
    dimensions: 'Various sizes available',
    customizability: ['Text content', 'Font style', 'Color scheme', 'Table size', 'Design placement'],
    inStock: true,
    featured: true
  },
  {
    id: '2',
    title: 'Slate Menu Board',
    description: 'Elegant slate boards with hand-crafted calligraphy. Perfect for restaurants, cafes, or home kitchens. Durable and beautiful.',
    price: 89.99,
    images: [img3, img4],
    category: 'Slates',
    dimensions: '12" x 18"',
    customizability: ['Menu items', 'Font style', 'Color scheme', 'Board size'],
    inStock: true,
    featured: true
  },
  {
    id: '3',
    title: 'Decorative Calligraphy Tray',
    description: 'Stunning calligraphy on elegant serving trays. Perfect for entertaining or as a decorative piece in your home.',
    price: 149.99,
    images: [img5, img6],
    category: 'Trays',
    dimensions: '16" x 12"',
    customizability: ['Text content', 'Font style', 'Color scheme', 'Tray material', 'Design placement'],
    inStock: true,
    featured: false
  },
  {
    id: '4',
    title: 'Personalized Calligraphy Jewelry',
    description: 'Delicate calligraphy on beautiful jewelry pieces. Perfect for gifts or personal keepsakes.',
    price: 79.99,
    images: [img7, img1],
    category: 'Jewelry',
    dimensions: 'Various sizes',
    customizability: ['Text content', 'Font style', 'Jewelry type', 'Material'],
    inStock: true,
    featured: false
  },
  {
    id: '5',
    title: 'Coffee Table with Calligraphy',
    description: 'Stunning coffee table featuring elegant calligraphy design. A conversation piece that adds sophistication to any living room.',
    price: 399.99,
    images: [img2, img3],
    category: 'Tables',
    dimensions: '48" x 24" x 18"',
    customizability: ['Text content', 'Font style', 'Color scheme', 'Table finish', 'Design placement'],
    inStock: true,
    featured: true
  },
  {
    id: '6',
    title: 'Kitchen Slate Board',
    description: 'Practical and beautiful slate board for your kitchen. Perfect for daily menus, grocery lists, or decorative quotes.',
    price: 69.99,
    images: [img4, img5],
    category: 'Slates',
    dimensions: '10" x 14"',
    customizability: ['Text content', 'Font style', 'Color scheme', 'Board style'],
    inStock: true,
    featured: false
  },
  {
    id: '7',
    title: 'Serving Tray Set',
    description: 'Set of 3 elegant serving trays with coordinated calligraphy designs. Perfect for entertaining and special occasions.',
    price: 199.99,
    images: [img6, img7],
    category: 'Trays',
    dimensions: 'Various sizes in set',
    customizability: ['Text content', 'Font style', 'Color scheme', 'Tray materials'],
    inStock: true,
    featured: false
  },
  {
    id: '8',
    title: 'Calligraphy Necklace',
    description: 'Delicate necklace featuring beautiful calligraphy. Perfect for everyday wear or special occasions.',
    price: 59.99,
    images: [img1, img2],
    category: 'Jewelry',
    dimensions: '18" chain length',
    customizability: ['Text content', 'Font style', 'Chain material', 'Pendant size'],
    inStock: true,
    featured: false
  }
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Sarah Johnson',
    role: 'Homeowner',
    content: 'The custom calligraphy on our dining table is absolutely stunning! It adds such an elegant touch to our home. Everyone who visits comments on how beautiful it is.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '2',
    name: 'Michael Chen',
    role: 'Restaurant Owner',
    content: 'The slate boards with calligraphy for our menu have made a huge impression on our customers. They\'re unique and professional - exactly what we were looking for.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    role: 'Interior Designer',
    content: 'The custom calligraphy tray I ordered is the perfect centerpiece for my client\'s living room. The calligraphy is so beautiful and the quality is outstanding.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  }
];

export const getProducts = (): Product[] => {
  return products;
};

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getFeaturedProducts = (): Product[] => {
  return products.filter(product => product.featured);
};

export const getProductsByCategory = (category: string): Product[] => {
  return products.filter(product => product.category === category);
};

export const getTestimonials = (): Testimonial[] => {
  return testimonials;
}; 